import { createAction } from 'redux-act';
import {
    IGetJuryCampaignSubmissions,
    IInviteJuryPayload,
    IJuryDuties,
    IAcceptJuryInvite,
    IScoreSubmission,
    ISubmissionResultsForContest,
    types,
    IGetJurorForContest,
    IAssignedSubmissionToJudge,
    IGetScoreBoard,
    IScoreBoardResponse,
    IScoreSubmissionResponse,
    IGetJuryCampaigns,
    IGetSubmissionsForAssignment,
    ISubmissionsAssignmentResponse,
    IAssignJuryDutyAdvanced,
    IDis,
    IJurySetings,
    IEmailJurorPayload,
    IInviteExternalJurorPayload,
} from './types';
import { IErrorType } from '../../constants/types';
import { IGenericDocumentModifier } from '../../types/global/helper';

export const inviteJury = createAction<IInviteJuryPayload>(types.INVITE_JURY);
export const inviteJurySuccess = createAction<IJuryDuties[]>(types.INVITE_JURY_SUCCESS);
export const inviteJuryFail = createAction<IErrorType>(types.INVITE_JURY_FAIL);

export const acceptJury = createAction<IAcceptJuryInvite>(types.ACCEPT_JURY_INVITE);
export const acceptJurySuccess = createAction<string>(types.ACCEPT_JURY_INVITE_SUCCESS);
export const acceptJuryFail = createAction<string>(types.ACCEPT_JURY_INVITE_FAIL);

export const getJuryCampaigns = createAction<IGetJuryCampaigns>(types.GET_JURY_CAMPAIGNS);
export const getJuryCampaignsSuccess = createAction<IJuryDuties[]>(types.GET_JURY_CAMPAIGNS_SUCCESS);
export const getJuryCampaignsFail = createAction<IErrorType>(types.GET_JURY_CAMPAIGNS_FAIL);

export const deleteJury = createAction<IGenericDocumentModifier>(types.DELETE_JURY);
export const deleteJurySuccess = createAction<IGenericDocumentModifier>(types.DELETE_JURY_SUCCESS);
export const deleteJuryFail = createAction<IErrorType>(types.DELETE_JURY_FAIL);

export const searchCampaignSubmission = createAction<IGetJuryCampaignSubmissions>(types.SEARCH_SUBMISSIONS);
export const searchCampaignSubmissionSuccess = createAction<ISubmissionResultsForContest>(
    types.SEARCH_SUBMISSIONS_SUCCESS,
);
export const searchCampaignSubmissionFail = createAction<IErrorType>(types.SEARCH_SUBMISSIONS_FAIL);

export const getCampaignSubmissions = createAction<IGetJuryCampaignSubmissions>(types.GET_CAMPAIGN_SUBMISSIONS);
export const getCampaignSubmissionsSuccess = createAction<ISubmissionResultsForContest>(
    types.GET_CAMPAIGN_SUBMISSIONS_SUCCESS,
);
export const getCampaignSubmissionsFail = createAction<IErrorType>(types.GET_CAMPAIGN_SUBMISSIONS_FAIL);

export const getSubmissionForAssignment = createAction<IGetSubmissionsForAssignment>(
    types.GET_SUBMISSIONS_FOR_ASSIGNMENT,
);
export const getSubmissionForAssignmentSuccess = createAction<ISubmissionsAssignmentResponse>(
    types.GET_SUBMISSIONS_FOR_ASSIGNMENT_SUCCESS,
);
export const getSubmissionForAssignmentFail = createAction<IErrorType>(types.GET_SUBMISSIONS_FOR_ASSIGNMENT_FAIL);

export const getCompletedCampaignSubmissions = createAction<IGetJuryCampaignSubmissions>(
    types.GET_COMPLETED_CAMPAIGN_SUBMISSIONS,
);
export const getCompletedCampaignSubmissionsSuccess = createAction<ISubmissionResultsForContest>(
    types.GET_COMPLETED_CAMPAIGN_SUBMISSIONS_SUCCESS,
);
export const getCompletedCampaignSubmissionsFail = createAction<IErrorType>(
    types.GET_COMPLETED_CAMPAIGN_SUBMISSIONS_FAIL,
);

export const getIncompleteCampaignSubmissions = createAction<IGetJuryCampaignSubmissions>(
    types.GET_INCOMPLETE_CAMPAIGN_SUBMISSIONS,
);
export const getIncompleteCampaignSubmissionsSuccess = createAction<ISubmissionResultsForContest>(
    types.GET_INCOMPLETE_CAMPAIGN_SUBMISSIONS_SUCCESS,
);
export const getIncompleteCampaignSubmissionsFail = createAction<IErrorType>(
    types.GET_INCOMPLETE_CAMPAIGN_SUBMISSIONS_FAIL,
);

export const scoreSubmission = createAction<IScoreSubmission>(types.SCORE_SUBMISSION);
export const scoreSubmissionSuccess = createAction<IScoreSubmissionResponse>(types.SCORE_SUBMISSION_SUCCESS);
export const scoreSubmissionFail = createAction<IErrorType>(types.SCORE_SUBMISSION_FAIL);

export const distributeSubmissionToJuries = createAction<IAssignJuryDutyAdvanced>(
    types.DISTRIBUTE_SUBMISSIONS_TO_JURIES,
);
export const distributeSubmissionToJuriesSuccess = createAction<IDis>(types.DISTRIBUTE_SUBMISSIONS_TO_JURIES_SUCCESS);
export const distributeSubmissionToJuriesFail = createAction<IErrorType>(types.DISTRIBUTE_SUBMISSIONS_TO_JURIES_FAIL);

export const getJurorForContest = createAction<IGetJurorForContest>(types.GET_JURORS_FOR_CONTEST);
export const getJurorForContestSuccess = createAction<IJuryDuties[]>(types.GET_JURORS_FOR_CONTEST_SUCCESS);
export const getJurorForContestFail = createAction<IErrorType>(types.GET_JURORS_FOR_CONTEST_FAIL);

export const assignSubmisisonToJuror = createAction<IAssignedSubmissionToJudge>(types.ASSIGN_SUBMISSION_TO_JUROR);
export const assignSubmisisonToJurorSuccess = createAction<IJuryDuties>(types.ASSIGN_SUBMISSION_TO_JUROR_SUCCESS);
export const assignSubmisisonToJurorFail = createAction<IErrorType>(types.ASSIGN_SUBMISSION_TO_JUROR_FAIL);

export const getScoreBoard = createAction<IGetScoreBoard>(types.GET_SCORE_BOARD);
export const getScoreBoardSuccess = createAction<IScoreBoardResponse>(types.GET_SCORE_BOARD_SUCCESS);
export const getScoreBoardFail = createAction<IErrorType>(types.GET_SCORE_BOARD_FAIL);

export const updateJury = createAction<IJurySetings>(types.UPDATE_JURY);
export const updateJurySuccess = createAction<IJuryDuties>(types.UPDATE_JURY_SUCCESS);
export const updateJuryFail = createAction<IErrorType>(types.UPDATE_JURY_FAIL);

export const emailJuror = createAction<IEmailJurorPayload>(types.EMAIL_JUROR);
export const emailJurorSuccess = createAction<IJuryDuties>(types.EMAIL_JUROR_SUCCESS);
export const emailJurorFail = createAction<IErrorType>(types.EMAIL_JUROR_FAIL);

export const inviteExternalJuror = createAction<IInviteExternalJurorPayload>(types.INVITE_EXTERNAL_JUROR);
export const inviteExternalJurorSuccess = createAction<IJuryDuties[]>(types.INVITE_EXTERNAL_JUROR_SUCCESS);
export const inviteExternalJurorFail = createAction<IErrorType>(types.INVITE_EXTERNAL_JUROR_FAIL);
